/*!
 * v-title v2.0.1
 * (c) 2019-2022 yujinpan
 * Released under the MIT License.
 */

import VTitle from './directives/title.js';
import styleInject from 'style-inject/dist/style-inject.es.js';

var css_248z = ".tippy-content{word-break:break-all}";
styleInject(css_248z);

// 主组件

VTitle.install = function (Vue) {
  Vue.directive('title', VTitle);
}; // Vue.component()

export default VTitle;
